import { ThreeItemKeys, ThreeItemTypes } from '../../../constants/three'
import { getObjectsByUserData } from '../../../helpers/scene-json'
import { createMutation, createQuery } from '@tanstack/svelte-query'
import { get } from 'svelte/store'
import { storeScene } from '../../../stores/scene'
import { focusOnObject } from '../../../stores/camera'
import queryClient from '../../../constants/query-client'
import { PrinterService } from '../../../services'
import useCanvasSelection from '../../../hooks/canvas-selection'
import { pendingPlacement } from '../../../stores/placement'

const usePrintersQueries = () => {
  const getPrinters = () => getObjectsByUserData(get(storeScene), ThreeItemKeys.ITEM_TYPE, ThreeItemTypes.PRINTER)
  const { upsert: selectObject } = useCanvasSelection()

  const invalidatePrinters = () => {
    queryClient.invalidateQueries({ queryKey: ['canvas', 'printers'] })
  }

  const usePrinters = () => createQuery(() => ({
    queryKey: ['canvas', 'printers'],
    queryFn: getPrinters,
  }), () => queryClient)

  const addPrinterMutation = createMutation(() => ({
    mutationFn: (model: PrinterModel) => PrinterService.buildGroup(model, get(storeScene)),
    onSuccess: (printerGroup, model) => {
      if (!printerGroup) return
      pendingPlacement.set({
        groups: [printerGroup],
        type: 'printer',
        printerModel: model,
        onPlaced: async () => {
          invalidatePrinters()
          await PrinterService.showFloorZone(
            get(storeScene),
            printerGroup.uuid,
            printerGroup.userData[ThreeItemKeys.GRID_TYPE],
          )
          selectObject(printerGroup)
          focusOnObject(printerGroup)
        },
      })
    },
  }), () => queryClient)

  return {
    usePrinters,
    addPrinterMutation,
    invalidatePrinters,
  }
}

export default usePrintersQueries
